import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import abstractReducer from "../slices/abstractSlice";
import paymentReducer from "../slices/paymentSlice";
import cartReducer from '../slices/cartSlice'; // Import the cart slice
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['auth', 'abstract', 'payment', 'cart'], // Include cart in the whitelist
};

const rootReducer = combineReducers({
  auth: authReducer,
  abstract: abstractReducer,
  payment: paymentReducer,
  cart: cartReducer, // Add cart reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
